import { AsyncSubject } from 'rxjs';
import { CLUSTER } from './constants';
import { socketReconnect } from './actions';
export class TrafficControlWebSocketConnection {
  constructor(store) {
    this.store = store;
    this.lostConnection = false;
    this.subscribe = fun => {
      return this.socketConnection.subscribe(fun);
    };
    this.socketConnection = this.open();
  }
  open() {
    const sub = new AsyncSubject();
    const socket = this.store.getState().socket;
    socket.onOpen(() => {
      if (this.lostConnection) {
        this.store.dispatch(socketReconnect(CLUSTER.CHAT));
      }
    });
    socket.onClose(() => {
      this.lostConnection = true;
    });
    sub.next(socket);
    sub.complete();
    return sub;
  }
}